<template>
  <div>
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <h1 class="h4 mb-1 font-weight-bold">My profile</h1>
        <p class="text-muted mb-0">Your name, sign-in email and password</p>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardBody>
            <div v-if="loadError" class="text-center p-5">
              <CIcon name="cil-warning" size="xl" class="text-danger mb-3" />
              <h2 class="h6 font-weight-bold">Couldn't load your profile</h2>
              <p class="text-muted">Check your connection and try again.</p>
              <CButton color="primary" @click="resetObj">Retry</CButton>
            </div>
            <CForm v-else @submit.prevent="submit">
              <CInput label="Name *" horizontal v-model="obj.fullName" />
              <CInput
                label="Email *"
                type="email"
                horizontal
                v-model="obj.email"
                :readonly="isEmailReadOnly"
              />

              <CRow form class="form-group">
                <CCol tag="label" sm="3" class="col-form-label"> Change password </CCol>
                <CCol sm="9">
                  <CSwitch class="mr-1" color="primary" :checked.sync="isResetPassword" />
                </CCol>
              </CRow>
              <CInput
                v-if="isResetPassword"
                description="At least 8 characters, with a capital letter, a number and a special character."
                label="New password *"
                type="password"
                horizontal
                autocomplete="new-password"
                v-model="plainPassword"
              />
            </CForm>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-end">
            <CButton color="primary" :disabled="saving || loadError" @click="submit">
              Save
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ProfileApi from "../../lib/profileApi";

export default {
  name: "Profile",
  data: () => {
    return {
      isResetPassword: false,
      plainPassword: "",
      isEmailReadOnly: false,
      api: new ProfileApi(),
      obj: {
        fullName: "",
        email: "",
      },
      saving: false,
      loadError: false,
    };
  },
  mounted() {
    this.resetObj();
  },
  methods: {
    submit() {
      var self = this;
      if (self.saving) return;
      var profileDto = {
        profile: self.obj,
        isResetPassword: self.isResetPassword,
        plainPassword: self.plainPassword,
      };
      self.saving = true;
      const request = !self.obj.id
        ? self.api.createProfileAppUser(profileDto)
        : self.api.updateProfileAppUser(profileDto);
      request
        .then(() => {
          self.$toast.success("Profile saved");
          self.plainPassword = "";
          self.resetObj();
        })
        .catch(({ data }) => {
          self.$toast.error("Couldn't save your profile. " + helper.getErrorMessage(data));
        })
        .finally(() => {
          self.saving = false;
        });
    },
    resetObj() {
      var self = this;
      self.loadError = false;
      self.api
        .getCurrentProfile()
        .then((response) => {
          self.obj = response.result;
        })
        .catch((error) => {
          console.error(error);
          self.loadError = true;
        });
      self.isResetPassword = false;
    },
  },
};
</script>
